import React from 'react';
import {Button, Dropdown, MenuProps, Space} from 'antd';
import {generatePath, useHistory} from "react-router-dom";
import {getHistoryRoute, getProgressRoute} from "../../pages/routes";
import {generateQueryHistoryViewTitle} from "./queryHistoryUtil";
import {ReactComponent as AllQueriesIcon} from './icons/AllQueries.svg';
import {ReactComponent as SavedQueriesIcon} from './icons/SavedQueries.svg';
import {ReactComponent as QueriesProgressIcon} from './icons/QueriesProgress.svg';
import {ReactComponent as FavouriteQueriesIcon} from './icons/FavouriteQueries.svg';
import {ReactComponent as CompanyQueriesIcon} from './icons/CompanyQueries.svg';
import './DropdownMenuQueryStyles.scss';
import buttonStyles from "../common/styled/Buttons.module.scss";
import {DownOutlined} from "@ant-design/icons";

interface QueryDropDownProps {
    isCohortAnalyser: boolean;
    hasCompanyQueryHistoryAccess: boolean;
}

export const QueriesDropDown = ({isCohortAnalyser, hasCompanyQueryHistoryAccess}: QueryDropDownProps) => {

    const history = useHistory()

    const onClick: MenuProps['onClick'] = ({key}) => {
        if (key === 'queryprogress') {
            history.push(getProgressRoute(isCohortAnalyser));
        } else {
            history.push(generatePath(getHistoryRoute(isCohortAnalyser), {filter: key}));
        }
    }

    const dropDownItems: MenuProps = {
        items: [
            {
                key: 'allquery',
                label: generateQueryHistoryViewTitle('allquery'),
                icon: <AllQueriesIcon className="query-icon"/>,
            },
            {
                key: 'mysavedquery',
                label: generateQueryHistoryViewTitle('mysavedquery'),
                icon: <SavedQueriesIcon className="query-icon"/>,
            },
            {
                key: 'queryprogress',
                label: generateQueryHistoryViewTitle('queryprogress'),
                icon: <QueriesProgressIcon className="query-icon"/>,
            },
            {
                key: 'favouritequery',
                label: generateQueryHistoryViewTitle('favouritequery'),
                icon: <FavouriteQueriesIcon className="query-icon"/>,
            },
            ...(hasCompanyQueryHistoryAccess ? [{
                key: 'companyquery',
                label: generateQueryHistoryViewTitle('companyquery'),
                icon: <CompanyQueriesIcon className="query-icon"/>,
            }] : [])
        ],
        onClick: onClick,
        className: "query-dropdown-menu"
    };

    return (
        <Dropdown menu={dropDownItems} className={buttonStyles.queriesDropdown}>
            <Button>
                <Space>
                    <AllQueriesIcon className={buttonStyles.queriesButtonIcon}/>
                    Queries
                    <DownOutlined />
                </Space>
            </Button>
        </Dropdown>

    )
}